export function readFieldFlat(record, field) { // TODO use Lodash _.get(record, field) ?
	// console.log(record)
	if (!record || !field) return record
	if (field.indexOf('.') === -1) return record[field]
	const [group, restOfField] = field.split('.', 2)
	return readFieldFlat(record[group], restOfField)
}

export function format(value, field) {
	if ((field || '').endsWith('_time')) {
		return new Date(value * 1000).toLocaleString()
	}
	return value || value === 0 ? value : null
}

export function formatForList(value, field) {
	if (value && value.constructor.name === 'Array') {
		return value.length + ' items'
	} else if (value && field.label_key !== undefined) {
		return value[field.label_key]
	}
	return format(value, field.field)
}

export function inputType(field) {
	if (!field) return 'text'
	if (field.type === 'number') return 'number'
	if (field.type === 'enum') return 'select'
	if (field.type === 'date') return 'datepicker'
	if (field.type === 'tags') return 'tags'
	return 'text'
}
